import React, { useEffect, useState, useMemo } from 'react';
import { formatDistanceToNow, format } from 'date-fns';
import { enUS, es, de, fr, it, ptBR, pt } from 'date-fns/locale';
import { useLanguage } from '../../hooks/useLanguage';

export function RelativeDate({ date, style, lang = 'en' }) {
  const [label, setLabel] = useState('');
  const [fullDate, setFullDate] = useState('');
  const [isRelative, setIsRelative] = useState(true);
  const { language } = useLanguage()
  const locales = { en: enUS, 'es-ES': es, de: de, fr: fr, it: it, "pt-BR": ptBR, pt: pt };
  const locale = locales[language] || enUS;

  // Crear la fecha de forma segura con validación
  const _createdDate = useMemo(() => {
    if (!date) return null;
    const parsedDate = new Date(date);
    return isNaN(parsedDate.getTime()) ? null : parsedDate;
  }, [date]);

  useEffect(() => {
    // Si la fecha no es válida, no hacer nada
    if (!_createdDate) {
      setLabel('');
      setFullDate('');
      return;
    }

    function updateLabel() {
      const now = new Date();
      const diffMinutes = Math.floor((now - _createdDate) / 60000);

      if (diffMinutes >= 60) {
        setLabel(format(_createdDate, 'dd-MM-yyyy HH:mm') + "hs.");
        setIsRelative(false);
      } else {
        setLabel(formatDistanceToNow(_createdDate, { addSuffix: true, locale }));
        setIsRelative(true);
      }
    }

    setFullDate(format(_createdDate, 'dd-MM-yyyy HH:mm') + "hs.");
    updateLabel();

    // Crear intervalo para actualizar cada minuto
    const interval = setInterval(updateLabel, 60000);
    
    return () => clearInterval(interval);
  }, [_createdDate, language]);

  const defaultStyle = {
    fontSize: 12,
    textTransform: 'capitalize',
  };

  return (
    <span 
      style={{ ...defaultStyle, ...style }}
      title={fullDate || ''}
    >
      {label}
    </span>
  );
}
